import { render } from "./ServicesComp.vue?vue&type=template&id=6fa7a8bb"
import script from "./ServicesComp.vue?vue&type=script&lang=js"
export * from "./ServicesComp.vue?vue&type=script&lang=js"

import "./ServicesComp.vue?vue&type=style&index=0&id=6fa7a8bb&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__